export default __webpack_public_path__ + "static/media/0.8f954cf1.jpg";